import React, { useState } from 'react';
import { Lock, LogIn } from 'lucide-react';
import { Input } from '../ui/input';
import { adminLogin } from '../../lib/adminApi';

export default function AdminLogin({ onLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const data = await adminLogin(username, password);
      onLoggedIn(data);
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0d10] flex items-center justify-center px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-[#14171c] border border-white/10 rounded-2xl p-7 space-y-5"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-full bg-orange-600/20 border border-orange-600/40 flex items-center justify-center">
            <Lock className="w-4 h-4 text-orange-500" />
          </div>
          <div>
            <h1 className="text-white text-sm font-semibold tracking-tight">Waxify Admin</h1>
            <p className="text-white/40 text-xs">Restricted access</p>
          </div>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-white/50 mb-1.5">Username</label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="h-10 bg-white/5 border-white/10 text-white placeholder:text-white/30"
              autoComplete="username"
              data-testid="admin-username-input"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-white/50 mb-1.5">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-10 bg-white/5 border-white/10 text-white placeholder:text-white/30"
              autoComplete="current-password"
              data-testid="admin-password-input"
            />
          </div>
        </div>

        {error && (
          <p className="text-xs text-red-400" data-testid="admin-login-error">{error}</p>
        )}

        <button
          type="submit"
          disabled={submitting || !username || !password}
          className="flex items-center justify-center gap-2 w-full h-10 rounded-lg bg-orange-600 hover:bg-orange-700 disabled:bg-white/10 disabled:text-white/30 text-white text-sm font-medium transition-colors"
          data-testid="admin-login-submit-button"
        >
          <LogIn className="w-3.5 h-3.5" /> {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
